import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AcademicsService {

  constructor(private http: HttpClient) { }


  //CalenderDayType
  getAllCalenderDayType() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmcdaytypes`);
  }

  addCalenderDayType(username: string, orgid: any, cdayTypeCode: string, cdayNameAr: string, cdayNameEn: string, workDayFlag: string, timeFrom: any, timeTo: any, active: string) {

    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/acmcdaytypes/${username}`, { orgid, cdayTypeCode, cdayNameAr, cdayNameEn, workDayFlag, timeFrom, timeTo, active });
  }
  updateCalenderDayType(username: string, id: any, orgid: any, cdayTypeCode: string, cdayNameAr: string, cdayNameEn: string, workDayFlag: string, timeFrom: any, timeTo: any, active: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/acmcdaytypes/${username}/${id}`, { id, orgid, cdayTypeCode, cdayNameAr, cdayNameEn, workDayFlag, timeFrom, timeTo, active });
  }


  getCalenderDayTypeById(id: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmcdaytypes/${id}`);
  }


  //Calender
  getAllCalender() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmcalendar`);
  }

  addCalender(username: string, orgid: any, effectiveFrom: any, effectiveTo: any, cdaytypeid: number, repeatsFlag: string, frequency: string, remarks: string, active: string) {

    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/acmcalendar/${username}`, { orgid, effectiveFrom, effectiveTo, cdaytypeid, repeatsFlag, frequency, remarks, active });
  }
  updateCalender(username: string, id: any, orgid: any, effectiveFrom: any, effectiveTo: any, cdaytypeid: number, repeatsFlag: string, frequency: string, remarks: string, active: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/acmcalendar/${username}/${id}`, { id, orgid, effectiveFrom, effectiveTo, cdaytypeid, repeatsFlag, frequency, remarks, active });
  }


  getCalenderById(id: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmcalendar/${id}`);
  }

  getTeachers() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmteachers`);
  }

  getTeacher(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmteachers/${id}`);
  }

  addTeacher(username: string, orgid: any, teacherCode: string, teacherNameAr: string, teacherNameEn: string, titleAr: string, titleEn: any, gender: any, teacherType: any) {
    let createdDate = new Date();
    let active = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/acmteachers/${username}`, { orgid, teacherCode, teacherNameAr, teacherNameEn, titleAr, titleEn, gender, teacherType, active });
  }

  updateTeacher(username: string, id: number, orgid: any, teacherCode: string, teacherNameAr: string, teacherNameEn: string, titleAr: string, titleEn: any, gender: any, teacherType: any, active: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/acmteachers/${username}/${id}`, { id, orgid, teacherCode, teacherNameAr, teacherNameEn, titleAr, titleEn, gender, teacherType, active });
  }

  getTeacherCourses() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmsubjectteachers`);
  }

  getTeacherCourse(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmsubjectteachers/${id}`);
  }

  addTeacherCourse(username: string, orgid: any, subjectid: number, teacherid: number, primarySecondary: string, remarks: any, active: any) {
    let createdDate = new Date();
    // let active = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/acmsubjectteachers/${username}`, { orgid, subjectid, teacherid, primarySecondary, remarks, createdDate, active });
  }

  updateTeacherCourse(username: string, id: number, orgid: any, subjectid: number, teacherid: number, primarySecondary: string, remarks: any, active: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/acmsubjectteachers/${username}/${id}`, { id, orgid, subjectid, teacherid, primarySecondary, remarks, active });
  }

  getTeacherCourseBycourseAndType(orgId: number,subId: number,type :string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmsubjectteachers/${orgId}/${subId}/${type}`);
  }

  // Get active courses
  getActiveSubjectList(orgid: number){
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmactivesubjects/${orgid}`);
  }

  // Get active teachers
  getActiveTeacherList(orgid: number){
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmactiveteachers/${orgid}`);
  }


  //Courses Categories APIs
  addCourseCategory(username: string, orgid: any, scatCode: string, scatNameAr: string, scatNameEn: string, scatHighlight: string) {
    let createdDate = new Date();
    let active = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/acmsubjectcategories/${username}`, { orgid,scatCode, scatNameAr, scatNameEn, scatHighlight,active });
  }

  updateCourseCategory(username: string, id: number, orgid: any, scatCode: string, scatNameAr: string, scatNameEn: string, scatHighlight: string, active: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/acmsubjectcategories/${username}/${id}`, { id, orgid, scatCode, scatNameAr, scatNameEn, scatHighlight, active });
  }

  getAllCourseCategory() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmsubjectcategories`);
  }

  getCourseCategoryBYId(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmsubjectcategories/${id}`);
  }

  //Mark Group APIs
  addMarkGroup(username: string, orgid: any, mgroupCode: string, mgroupNameAr: string, mgroupNameEn: string) {
    let createdDate = new Date();
    let active = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/scrmarkgroups/${username}`, { orgid,mgroupCode, mgroupNameAr, mgroupNameEn,active });
  }

  updateMarkGroup(username: string, id: number, orgid: any, mgroupCode: string, mgroupNameAr: string, mgroupNameEn: string, active: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/scrmarkgroups/${username}/${id}`, { id, orgid, mgroupCode, mgroupNameAr, mgroupNameEn, active });
  }

  getAllMarkGroup() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrmarkgroups`);
  }

  getMarkGroupBYId(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrmarkgroups/${id}`);
  }

  //Mark  APIs
  addMark(username: string, orgid: any, mgroupid: any, markNameAr: string, markNameEn: string,markLetter:string,markPercentage:any,gpaProm:any,gpaTo:any) {
    let createdDate = new Date();
    let active = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/scrmarks/${username}`, { orgid,mgroupid,markLetter,markNameAr,markNameEn,markPercentage, gpaProm, gpaTo,active });
  }

  updateMark(username: string, id: number, orgid: any ,mgroupid: any,markLetter:string, markNameAr: string, markNameEn: string,markPercentage:any,gpaProm:any,gpaTo:any,active: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/scrmarks/${username}/${id}`, { id, orgid,mgroupid,markLetter,markNameAr,markNameEn,markPercentage, gpaProm, gpaTo,active });
  }

  getAllMark() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrmarks`);
  }

  getMarkBYId(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrmarks/${id}`);
  }

    getcalendardayscount(orgId:any,date1: Date,date2: Date) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/getcalendardayscount/${orgId}/${date1}/${date2}`);
  }

  
  promoteEnrolledStudents(orgId:any,year: number,semster: number,username:String) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/promoteEnrolledStudents/${orgId}/${year}/${semster}/${username}`);
  }

  promoteEnrolledStudentsUndo(orgId:any,year: number,semster: number,username:String) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/promoteenrolledstudentsundo/${orgId}/${year}/${semster}/${username}`);
  }


  
  getAllErlGroups() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlgroups`);
  }

  addSemesterStudentGroup(username: string, orgid: any, egroupCode: string, egroupNameAr: string, egroupNameEn: string,egroupType:String,subjectid:any, orderNo: string, active: string) {

    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/erlgroups/${username}`, { orgid, egroupCode, egroupNameAr, egroupNameEn,egroupType,subjectid, orderNo, active });
  }
  
  updateSemesterStudentGroup(username: string, id: any, orgid: any, egroupCode: string, egroupNameAr: string, egroupNameEn: string, egroupType: string,subjectid:any, orderNo: any, active: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/erlgroups/${username}/${id}`, { id, orgid, egroupCode, egroupNameAr, egroupNameEn, egroupType,subjectid, orderNo, active });
  }


  getSemesterStudentGroup(id: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlgroups/${id}`);
  }

  // updateCalenderDayType(username: string, id: any, orgid: any, cdayTypeCode: string, cdayNameAr: string, cdayNameEn: string, workDayFlag: string, timeFrom: any, timeTo: any, active: string) {
  //   return this.http.put<any>(
  //     `${environment.API_URL_ADM}/api/acmcdaytypes/${username}/${id}`, { id, orgid, cdayTypeCode, cdayNameAr, cdayNameEn, workDayFlag, timeFrom, timeTo, active });
  // }

}
